import type { TaskTrackerBoardSticker } from '../store/taskTracker.types'
import { isTaskTrackerSystemStickerFieldType } from './taskTrackerBoard.stickerFilters.utils'
import {
  TASK_TRACKER_COLUMN_SORT_POSITION_VALUE,
  TASK_TRACKER_COLUMN_SORT_SYSTEM_OPTIONS,
} from './taskTrackerColumnSort.constants'

export type TaskTrackerColumnSortOrder = 'asc' | 'desc'

export type TaskTrackerColumnSortOption = {
  value: string
  label: string
}

export const buildTaskTrackerColumnSortStickerValue = (fieldSettingId: number) =>
  `sticker:${fieldSettingId}`

export const buildTaskTrackerColumnSortOptions = (
  stickers: TaskTrackerBoardSticker[] = [],
): TaskTrackerColumnSortOption[] => {
  const stickerOptions = stickers
    .filter(
      (sticker) =>
        sticker.isVisible && !isTaskTrackerSystemStickerFieldType(sticker.fieldType),
    )
    .map((sticker) => ({
      value: buildTaskTrackerColumnSortStickerValue(sticker.fieldSettingId),
      label: sticker.title,
    }))

  return [...TASK_TRACKER_COLUMN_SORT_SYSTEM_OPTIONS, ...stickerOptions]
}

export const isTaskTrackerDefaultColumnSort = (sortField: string) =>
  sortField === TASK_TRACKER_COLUMN_SORT_POSITION_VALUE || sortField === 'none'

export const resolveTaskTrackerColumnSortApiParams = (
  sortField: string,
  sortOrder: TaskTrackerColumnSortOrder,
): { sortBy?: string; sortOrder?: TaskTrackerColumnSortOrder } => {
  if (isTaskTrackerDefaultColumnSort(sortField)) {
    return {}
  }

  return {
    sortBy: sortField,
    sortOrder,
  }
}
